<template>
	<el-dialog
		title="评价商品"
		:visible.sync="dialogVisible"
		width="650px"
		:before-close="handleClose"
		custom-class="evaluate-dialog"
	>
		<div class="evaluate-content">
			<div class="form-item">
				<div class="form-label">评价商品</div>
				<div class="form-control">
					<el-radio-group v-model="radiovalue" @change="groupChange">
						<el-radio
							v-for="(item, index) in radiolist"
							:key="index"
							:label="item.id"
							:style="{color: radiovalue === item.id ? '#3c9c8f' : '',marginTop: '20px'}"
						>
							{{ item.name }}
						</el-radio>
					</el-radio-group>
				</div>
			</div>
			
			<div class="form-item">
				<div class="form-label">评价评分</div>
				<div class="form-control">
					<el-rate v-model="score" :colors="rateColors" :max="5"></el-rate>
				</div>
			</div>
			
			<div class="form-item">
				<div class="form-label">上传图片</div>
				<div class="form-control">
					<el-upload
						action="#"
						list-type="picture-card"
						:file-list="fileList"
						:on-preview="handlePictureCardPreview"
						:on-remove="handleRemove"
						:auto-upload="false"
						:limit="9"
						:on-change="handleUploadChange"
					>
						<i class="el-icon-plus"></i>
					</el-upload>
					<el-dialog :visible.sync="dialogImageVisible">
						<img width="100%" :src="dialogImageUrl" alt="">
					</el-dialog>
				</div>
			</div>
			
			<div class="form-item">
				<div class="form-label">评价内容</div>
				<div class="form-control">
					<el-input
						type="textarea"
						:rows="4"
						placeholder="填写评价"
						v-model="evaluateContent"
					></el-input>
				</div>
			</div>
		</div>
		
		<span slot="footer" class="dialog-footer">
			<el-button @click="handleClose">取消</el-button>
			<el-button type="primary" @click="submit" :style="{backgroundColor: '#3c9c8f', borderColor: '#3c9c8f'}">提交评价</el-button>
		</span>
	</el-dialog>
</template>

<script>
	import { mapGetters } from 'vuex'
	export default {
		name: 'Evaluate',
		props: {
			dialogVisible: {
				type: Boolean,
				default: false
			},
			orderId: {
				type: String,
				default: ''
			}
		},
		data() {
			return {
				fileList: [],
				images: [],
				order_id: '',
				order: {},
				score: 5,
				radiolist: [],
				radiovalue: '',
				goods_id: '',
				evaluateContent: '',
				dialogImageUrl: '',
				dialogImageVisible: false,
				rateColors: ['#99A9BF', '#F7BA2A', '#FF9900']
			}
		},
		computed: {
			...mapGetters(['base'])
		},
		watch: {
			orderId: {
				handler(val) {
					if (val) {
						this.order_id = val
						this.getOrder()
					}
				},
				immediate: true
			},
			dialogVisible(val) {
				if (val && this.order_id) {
					this.getOrder()
				}
			}
		},
		methods: {
			groupChange(n) {
				this.goods_id = n
			},
			handleUploadChange(file, fileList) {
                this.$api.upload({
                        file: file.raw
                        }).then(res => {
                        if(res.code === 1){
                            this.images.push(res.data.fullurl);
                        }
                        }).catch(err => {
                        console.log(err);
                        });
			},
			handleRemove(file, fileList) {
				// 移除图片
				const index = this.fileList.findIndex(item => item.uid === file.uid)
				if (index !== -1) {
					this.images.splice(index, 1)
					this.fileList = fileList
				}
			},
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url
				this.dialogImageVisible = true
			},
			handleClose() {
				this.$emit('update:dialogVisible', false)
			},
			resetForm() {
				this.radiovalue = ''
				this.score = 5
				this.evaluateContent = ''
				this.images = []
				this.fileList = []
			},
			getOrder() {
				this.$api.getOrderDetail({id: this.order_id}).then(res => {
					if (res.code == 1) {
						this.order = res.data
						this.radiolist = this.order.goods_info.map(item => {
							return {
								name: item.title,
								id: item.id,
							}
						})
						if (this.radiolist.length > 0) {
							this.radiovalue = this.radiolist[0].id
							this.goods_id = this.radiolist[0].id
						}
					} else {
						this.$message.error(res.message)
					}
				})
			},
			submit() {
				if (!this.goods_id) {
					return this.$message.warning('请选择评价商品')
				}
				
				if (this.evaluateContent.trim() === '') {
					return this.$message.warning('请填写评价内容')
				}
				
				let data = {
					order_id: this.order_id, // 订单ID
					goods_id: this.goods_id, // 商品ID
					content: this.evaluateContent, // 评论内容
					score: this.score, // 评分
					images: this.images, // 评论图片（数组）
				}
				
				this.$api.postComment(data).then(res => {
					if (res.code == 1) {
						this.$message.success(res.message)
						this.handleClose()
						this.resetForm()
						this.$emit('evaluate-success')
					} else {
						this.$message.error(res.message)
					}
				}).catch(err => {
					console.log(err)
					this.$message.error('提交评价失败，请稍后重试')
				})
			}
		}
	}
</script>

<style lang="less" scoped>
	.evaluate-dialog {
		.evaluate-content {
			padding: 0 20px;
		}
		
		.form-item {
			margin-bottom: 20px;
			
			.form-label {
				font-size: 14px;
				color: #333;
				margin-bottom: 10px;
				font-weight: 500;
			}
			
			.form-control {
				width: 100%;
			}
		}
	}
    .dialog-footer{
  padding-right: 20px;
}
	/deep/ .el-radio__input.is-checked+.el-radio__label {
		color: #3c9c8f;
	}

	/deep/ .el-radio__input.is-checked .el-radio__inner {
		border-color: #3c9c8f;
		background: #3c9c8f;
	}

	/deep/ .el-textarea__inner:focus {
		border-color: #3c9c8f;
	}

	/deep/ .el-upload--picture-card:hover, 
	/deep/ .el-upload:focus {
		border-color: #3c9c8f;
		color: #3c9c8f;
	}
</style>
